import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const localStorageName = "depotfinder.20200407";

// Set initial states
const initialDepotFinderState = () => {
  return {
    depotfinder: {
      decision: [],
      age: "",
      orders: [],
      assets: "",
      services: []
    },
    recommendedDeposit: "",
    activeDeposit: "",
    alternativeDeposit: "",
    activeDepositTab: "",
    information: {
      selectedModels: [],
      selectedSpecialModels: []
    },
    views: {
      compareView: false,
      changeTarrifView: false,
      informationView: false,
      formSuccess: false,
      overlayBG: false
    },
    depositModels: {
      DepotDirekt: {
        name: "DepotDirekt",
        show: true,
        active: true
      },
      DepotKomfort: {
        name: "DepotKomfort",
        show: true,
        active: true
      },
      DepotExklusiv: {
        name: "DepotExklusiv",
        show: true,
        active: true
      },
      DepotExklusiv50: {
        name: "DepotExklusiv50",
        show: false,
        active: true
      },
      DepotExklusiv100: {
        name: "DepotExklusiv100",
        show: false,
        active: true
      },
      DepotFuture: {
        name: "DepotFuture",
        show: true,
        active: true
      },
      MeinVermögen: {
        name: "MeinVermögen",
        show: false,
        active: true
      },
      Vermögensverwaltung: {
        name: "Vermögensverwaltung",
        show: false,
        active: true
      }
    },
    prevRoute: ""
  };
};

const store = new Vuex.Store({
  state: initialDepotFinderState(),
  mutations: {
    initialiseStore(state) {
      // Check if localstorage data exists
      if (localStorage.getItem(localStorageName)) {
        // Replace the state object with the stored item
        this.replaceState(
          Object.assign(
            state,
            JSON.parse(localStorage.getItem(localStorageName))
          )
        );
      }
    },
    updateDecisionState(state, payload) {
      state.depotfinder.decision = payload;
    },
    updateAgeState(state, payload) {
      state.depotfinder.age = payload;
    },
    updateOrdersState(state, payload) {
      state.depotfinder.orders = payload;
    },
    updateAssetsState(state, payload) {
      state.depotfinder.assets = payload;
    },
    updateServicesState(state, payload) {
      state.depotfinder.services = payload;
    },
    updateRecommendedDeposit(state, payload) {
      state.recommendedDeposit = payload;
    },
    resetDepositFinderState(state) {
      Object.assign(state, initialDepotFinderState());
    },
    updateDepositModels(state, payload) {
      state.depositModels = payload;
    },
    updateDepositModelVisibility(state, { model, payload }) {
      state.depositModels[model].show = payload;
    },
    updateDepositModelStatus(state, { model, payload }) {
      state.depositModels[model].active = payload;
    },
    updateView(state, { view, payload }) {
      state.views[view] = payload;
    },
    updateActiveDeposit(state, payload) {
      state.activeDeposit = payload;
    },
    updateAlternativeDeposit(state, payload) {
      state.alternativeDeposit = payload;
    },
    updateActiveDepositTab(state, payload) {
      state.activeDepositTab = payload;
    },
    updateInformationState(state, { index, payload }) {
      state.information[index] = payload;
    },
    updatePrevRoute(state, payload) {
      state.prevRoute = payload;
    }
  },
  actions: {
    updateDecisionState(context, payload) {
      context.commit("updateDecisionState", payload);
    },
    updateAgeState(context, payload) {
      context.commit("updateAgeState", payload);
    },
    updateOrdersState(context, payload) {
      context.commit("updateOrdersState", payload);
    },
    updateAssetsState(context, payload) {
      context.commit("updateAssetsState", payload);
    },
    updateServicesState(context, payload) {
      context.commit("updateServicesState", payload);
    },
    updateRecommendedDeposit(context, payload) {
      context.commit("updateRecommendedDeposit", payload);
    },
    resetDepositFinderState(context) {
      context.commit("resetDepositFinderState");
    },
    updateDepositModels(context, payload) {
      context.commit("updateDepositModels", payload);
    },
    updateDepositModelVisibility(context, { model, payload }) {
      context.commit("updateDepositModelVisibility", { model, payload });
    },
    updateDepositModelStatus(context, { model, payload }) {
      context.commit("updateDepositModelStatus", { model, payload });
    },
    updateView(context, { view, payload }) {
      context.commit("updateView", { view, payload });
    },
    updateActiveDeposit(context, payload) {
      context.commit("updateActiveDeposit", payload);
    },
    updateAlternativeDeposit(context, payload) {
      context.commit("updateAlternativeDeposit", payload);
    },
    updateActiveDepositTab(context, payload) {
      context.commit("updateActiveDepositTab", payload);
    },
    updateInformationState(context, { index, payload }) {
      context.commit("updateInformationState", { index, payload });
    },
    updatePrevRoute(context, payload) {
      context.commit("updatePrevRoute", payload);
    }
  },
  getters: {
    getDecisionState(state) {
      return state.depotfinder.decision;
    },
    getAgeState(state) {
      return state.depotfinder.age;
    },
    getOrdersState(state) {
      return state.depotfinder.orders;
    },
    getAssetsState(state) {
      return state.depotfinder.assets;
    },
    getServicesState(state) {
      return state.depotfinder.services;
    },
    getRecommendedDeposit(state) {
      return state.recommendedDeposit;
    },
    getDepositModels(state) {
      return Object.values(state.depositModels);
    },
    getFilteredDepositModels() {
      return store.getters.getDepositModels.filter(m => m.show);
    },
    getCompareViewState(state) {
      return state.views.compareView;
    },
    getChangeTarrifViewState(state) {
      return state.views.changeTarrifView;
    },
    getInformationViewState(state) {
      return state.views.informationView;
    },
    getOverlayBGState(state) {
      return state.views.overlayBG;
    },
    getFormSuccessState(state) {
      return state.views.formSuccess;
    },
    getActiveDeposit(state) {
      return state.activeDeposit;
    },
    getAlternativeDeposit(state) {
      return state.alternativeDeposit;
    },
    getActiveDepositTab(state) {
      return state.activeDepositTab;
    },
    getSelectedModelsInformationState(state) {
      return state.information.selectedModels;
    },
    getSelectedSpecialModelsInformationState(state) {
      return state.information.selectedSpecialModels;
    },
    getPrevRoute(state) {
      return state.prevRoute;
    }
  }
});

// Hide DepotFuture if Age > 27
store.watch(
  state => state.depotfinder.age,
  oldValue => {
    if (oldValue == "older") {
      store.dispatch("updateDepositModelVisibility", {
        model: "DepotFuture",
        payload: false
      });
    } else if (oldValue == "younger") {
      store.dispatch("updateDepositModelVisibility", {
        model: "DepotFuture",
        payload: true
      });
    }
  }
);

// Disable DepotDirekt if "adviser" option was selected step 1
store.watch(
  state => state.depotfinder.decision,
  oldValue => {
    if (oldValue.indexOf("adviser") != -1) {
      store.dispatch("updateDepositModelStatus", {
        model: "DepotDirekt",
        payload: false
      });
    } else if (oldValue.indexOf("adviser") == -1) {
      store.dispatch("updateDepositModelStatus", {
        model: "DepotDirekt",
        payload: true
      });
    }
  }
);

// Set initial selectedModels for information when activeModel is set
store.watch(
  state => state.activeDeposit,
  newValue => {
    // Differentiate between regular and special depositModels
    if (newValue != "MeinVermögen" && newValue != "Vermögensverwaltung") {
      // Regular depositModels
      if (newValue != "") {
        store.dispatch("updateInformationState", {
          index: "selectedModels",
          payload: [newValue]
        });
      }
    } else {
      // Special depositModels
      if (newValue != "") {
        if (store.getters.getDecisionState.indexOf("bank") != -1) {
          store.dispatch("updateInformationState", {
            index: "selectedSpecialModels",
            payload: [newValue]
          });
        }
      }
    }
  }
);

store.watch(
  state => state.views.informationView,
  () => {
    if (store.getters.getFormSuccessState == true) {
      store.dispatch("updateView", {
        view: "formSuccess",
        payload: false
      });
    }
  }
);

// Swap regular depositModels with special cases
store.watch(
  state => state.recommendedDeposit,
  oldValue => {
    if (oldValue == "MeinVermögen" || oldValue == "Vermögensverwaltung") {
      // First, disable all regular DepositModels
      store.getters.getFilteredDepositModels.forEach(model => {
        store.dispatch("updateDepositModelVisibility", {
          model: model.name,
          payload: false
        });
      });
      // Then enable special cases MeinVermögen/Vermögensverwaltung
      store.dispatch("updateDepositModelVisibility", {
        model: "MeinVermögen",
        payload: true
      });
      store.dispatch("updateDepositModelVisibility", {
        model: "Vermögensverwaltung",
        payload: true
      });
    } else {
      // Reset visibility for default depositModels
      if (store.state.route.name == "depotfinder.decision") {
        store.getters.getDepositModels.forEach(model => {
          store.dispatch("updateDepositModelVisibility", {
            model: model.name,
            payload: true
          });
        });
        // Disable DepotFuture again, if > 27
        if (store.getters.getAgeState == "older") {
          store.dispatch("updateDepositModelVisibility", {
            model: "DepotFuture",
            payload: false
          });
        }
        // Disable MeinVermögen/Vermögensverwaltung
        store.dispatch("updateDepositModelVisibility", {
          model: "MeinVermögen",
          payload: false
        });
        store.dispatch("updateDepositModelVisibility", {
          model: "Vermögensverwaltung",
          payload: false
        });
        // Disable DepotExklusiv50/100
        store.dispatch("updateDepositModelVisibility", {
          model: "DepotExklusiv50",
          payload: false
        });
        store.dispatch("updateDepositModelVisibility", {
          model: "DepotExklusiv100",
          payload: false
        });
      }
    }
  }
);

// Subscribe to store updates and save them to localstorage
store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  localStorage.setItem(localStorageName, JSON.stringify(state));
});

export default store;
